import startsWith from 'lodash/startsWith';
import { languages, language, shareUrl } from '../constants';
import stripTrailingSlash from './stripTrailingSlash';

const removeLocalePrefix = (route) => {
  if (!route || route === '/') {
    return '';
  }

  let cleanRoute = route;

  languages.forEach(({ value }) => {
    if (route === `/${value}`) {
      cleanRoute = '';
    }

    if (startsWith(route, `/${value}/`)) {
      cleanRoute = route.slice(value.length + 2);
    }
  });

  if (startsWith(cleanRoute, '/')) {
    cleanRoute = cleanRoute.slice(1);
  }

  return stripTrailingSlash(cleanRoute);
};

export default function multiLanguageTags(route, locale) {
  return languages
    .filter(lang => lang.value !== locale)
    .map(({ value }) => {
      const partRoute = removeLocalePrefix(route);
      const linkHref = `${shareUrl}/${value}/${partRoute}`;
      const link = {
        rel: 'alternate',
        hrefLang: value,
        href: stripTrailingSlash(linkHref)
      };
      if (value === language.default) {
        link.href = (partRoute === '') ? shareUrl : `${shareUrl}/${partRoute}`;
      }

      return link;
    });
}

